const PARTNERS = [
    "PARAMOUNT",
    "LIONSGATE",
    "NETFLIX",
    "PRIME VIDEO",
    "A24",
    "CINESURYA",
    "STARVISION",
    "STARZ",
];

export default function Marquee() {
    const items = [...PARTNERS, ...PARTNERS];
    return (
        <section
            data-testid="services-marquee"
            aria-label="Clients and partners"
            className="relative overflow-hidden border-y border-white/5 bg-[#070708] py-7 sm:py-9"
        >
            <div className="marquee-track">
                {items.map((name, i) => (
                    <span
                        key={`${name}-${i}`}
                        data-testid={i < PARTNERS.length ? `services-marquee-item-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}` : undefined}
                        aria-hidden={i >= PARTNERS.length}
                        className="flex items-center whitespace-nowrap"
                    >
                        <span className="font-display text-2xl sm:text-4xl font-bold uppercase tracking-tight text-neutral-600 px-8 sm:px-12">
                            {name}
                        </span>
                        <span className="h-1.5 w-1.5 rounded-full bg-[#FF3333]/70" aria-hidden="true" />
                    </span>
                ))}
            </div>
        </section>
    );
}
